import React from "react";

import Subtasks, { SubtasksProps } from "./Subtasks";
import NewTaskInput, { NewTaskInputProps } from "./NewTaskInput";

import useStyles from "./styles";

type SubTaskAreaProps = SubtasksProps &
  NewTaskInputProps & {
    pendingAdd: string[];
    setExistingSubtasks: CallableFunction;
    showClosedTask?: boolean;
  };

const SubTaskArea: React.FC<SubTaskAreaProps> = ({
  canEdit,
  existingSubtasks,
  setPending,
  pendingDelete,
  queueForDelete,
  pendingAdd,
  setExistingSubtasks,
  showClosedTask = true,
  ...taskInputProps
}) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Subtasks
        existingSubtasks={existingSubtasks}
        setPending={setPending}
        pendingDelete={pendingDelete}
        queueForDelete={queueForDelete}
        setExistingSubtasks={setExistingSubtasks}
        showClosedTask={showClosedTask}
      />

      <div
        className={classes.subtasks}
        style={
          (existingSubtasks?.length ?? 0) === 0 ? { marginTop: "1rem" } : {}
        }
      >
        {pendingAdd.map((subtask, i) => (
          <div key={`${subtask}-${i}`} className={classes.subtask}>
            {subtask}
          </div>
        ))}
      </div>

      <NewTaskInput canEdit={canEdit} {...taskInputProps} />
    </div>
  );
};

export default SubTaskArea;
